import { render, staticRenderFns } from "./IncompatibleVersionsDialog.vue?vue&type=template&id=0398be00"
import script from "./IncompatibleVersionsDialog.vue?vue&type=script&lang=ts"
export * from "./IncompatibleVersionsDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports